import { useCookies } from 'react-cookie'

const COOKIE_NAME = 'mobileControlToggles'

type MobileControlToggles = {
  quickAdd: boolean
  deckFilter: boolean

  view: boolean
  group: boolean
  sort: boolean
  prices: boolean

  stickyBar: boolean
}

export const useMobileControlToggles = (): [
  MobileControlToggles,
  (updatedToggles: Partial<MobileControlToggles>) => void,
] => {
  const [{ [COOKIE_NAME]: cookie = {} }, setCookies] = useCookies([COOKIE_NAME])

  const mobileControlToggles: MobileControlToggles = {
    quickAdd: `${cookie?.quickAdd}` === 'true',
    deckFilter: `${cookie?.deckFilter}` === 'true',

    view: `${cookie?.view}` === 'true',
    group: `${cookie?.group}` === 'true',
    sort: `${cookie?.sort}` === 'true',
    prices: `${cookie?.prices}` === 'true',

    stickyBar: `${cookie.stickyBar}` === 'true',
  }

  const handleUpdateToggles = (updates: Partial<MobileControlToggles>) => {
    setCookies(
      COOKIE_NAME,
      { ...mobileControlToggles, ...updates },
      { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365) },
    )
  }

  return [mobileControlToggles, handleUpdateToggles]
}
